<app-breadcrumb [crumbPaths]="[{
    name: 'Home',
    path: '/home'
}, {
    name: 'Survey',
    path: '/survey'
}, {
    name: 'Forms',
    path: '/form',
    active: true
}]">
</app-breadcrumb>
<app-page-header title="Forms" [buttons]="[{
    name: 'Add',
    eventName: 'add',
    cssClass: 'bg-primary'
}]" (onButtonClick)="action($event)">
</app-page-header>
<app-page-content>
    <app-data-grid [dataSource]="dataSource" [config]="config" [dataLength]="dataSource.length" [isLoading]="isLoading"
        (dataActionEvent)="action($event)">
    </app-data-grid>
</app-page-content>